import { observer } from 'mobx-react-lite';
import { useStore } from '../../lib/hooks/useStore';
import style from './style.module.scss';
import { useEffect } from 'react';
import clockImage from '../../assets/FaRegClock.svg';
import MessageBox from '../message-box';
import Confirm from '../confirm';

const SessionCountdown = observer(() => {
	const {
		sessionStore: { countdownSeconds, cancelCountdown },
		uiStore: { setShowModal },
		configStore: { getString },
	} = useStore();

	useEffect(() => {
		setShowModal(true);
		return () => {
			setShowModal(false);
		};
	}, [setShowModal]);

	return (
		<div className={style.timeout}>
			<h1 className={style.timeout__title}>{getString('timeout-title')}</h1>
			<img className={style.timeout__logo} src={clockImage} alt='Clock' />
			<MessageBox className={style.timeout__message} type={'warning'}>
				{getString('timeout-warning').replace('$$seconds$$', countdownSeconds?.toString() || '0')}
			</MessageBox>
			<Confirm
				titleLabel={getString('timeout-question')}
				className={style.timeout__confirm}
				yesButton={{ label: getString('timeout-yes'), value: 'yes' }}
				yesCallback={cancelCountdown}
			/>
		</div>
	);
});

export default SessionCountdown;
